import { importService } from '@/services';

export const importModule = {
  namespaced: true,
  state: () => ({
    list: {
      data: null,
      response: null,
      status: 'idle',
    },
    listFilters: {},
    download:{
      data: null,
      response: null,
      status: 'idle',
    },
    logsList: {
      data: null,
      response: null,
      status: 'idle',
    },
    logsListFilters: {},
    logsExport: {
      data: null,
      response: null,
      status: 'idle',
    }
  }),
  mutations: {
    setListError(state, response) {
      state.list.data = null;
      state.list.response = response;
      state.list.status = 'error';
    },
    setListLoading(state) {
      state.list.data = null;
      state.list.response = null;
      state.list.status = 'loading';
    },
    setListSuccess(state, response) {
      state.list.data = response?.data || null;
      state.list.response = response;
      state.list.status = 'success';
    },
    setListFilters(state, request) {
      state.listFilters = { ...JSON.parse(JSON.stringify(request)) }
    },
    setDownloadError(state, response) {
      state.download.data = null;
      state.download.response = response;
      state.download.status = 'error';
    },
    setDownloadLoading(state) {
      state.download.data = null;
      state.download.response = null;
      state.download.status = 'waiting';
    },
    setDownloadSuccess(state, response) {
      state.download.data = response?.data || null;
      state.download.response = response;
      state.download.status = 'success';
    },
    setLogsListError(state, response) {
      state.logsList.data = null;
      state.logsList.response = response;
      state.logsList.status = 'error';
    },
    setLogsListLoading(state) {
      state.logsList.data = null;
      state.logsList.response = null;
      state.logsList.status = 'loading';
    },
    setLogsListSuccess(state, response) {
      state.logsList.data = response?.data || null;
      state.logsList.response = response;
      state.logsList.status = 'success';
    },
    setLogsListFilters(state, request) {
      state.logsListFilters = { ...JSON.parse(JSON.stringify(request)) }
    },
    setLogsExportError(state, response) {
      state.logsExport.data = null;
      state.logsExport.response = response;
      state.logsExport.status = 'error';
    },
    setLogsExportLoading(state) {
      state.logsExport.data = null;
      state.logsExport.response = null;
      state.logsExport.status = 'waiting';
    },
    setLogsExportSuccess(state, response) {
      state.logsExport.data = response?.data || null;
      state.logsExport.response = response;
      state.logsExport.status = 'success';
    }
  },
  actions: {
    async getImports({ commit }, request) {
      commit('setListLoading');
      commit('setListFilters', request);
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const response = await importService.getImports(request.filters, request.pagination, user.customer._id);
        commit('setListSuccess', response);
      } catch (error) {
        commit('setListError', error);
        throw error;
      }
    },
    async downloadFile({ commit }, request) {
      commit('setDownloadLoading');
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const response = await importService.downloadFile(request.processId, request.filename, user.customer._id);
        commit('setDownloadSuccess', response);
      } catch (error) {
        commit('setDownloadError', error);
        throw error;
      }
    },
    async getImportLogs({ commit }, request) {
      commit('setLogsListLoading');
      commit('setLogsListFilters', request);
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const response = await importService.getImportLogs(request.processId, request.filters, request.pagination, user.customer._id);
        commit('setLogsListSuccess', response);
      } catch (error) {
        commit('setLogsListError', error);
        throw error;
      }
    },
    async exportImportLogs({ commit }, request) {
      commit('setLogsExportLoading');
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const response = await importService.exportImportLogs(request.processId, request.language, user.customer._id);
        commit('setLogsExportSuccess', response);
      } catch (error) {
        commit('setLogsExportError', error);
        throw error;
      }
    }
  }
}




/* import { batchLoadsService } from '@/services';

export const batchLoadsModule = {
  namespaced: true,
  state: () => ({
    list:{
      data: null,
      error: null,
    },
    listFilters: {},
    resource:{
      data: null,
      error: null,
    },
  }),
  mutations: {
    load(state,request) {
      state.listFilters = { ...JSON.parse(JSON.stringify(request)) }
      batchLoadsService.getBatchLoadsList(request.pagination,request.filters)
      .then((res) => {
        console.log(res)
        state.list.data = res
      })
      .catch((error) => {
        state.list.data = null
        state.list.error = error
      });    
    },
    downloadResource(state, request){
      batchLoadsService.downloadResource(request)
      .then((file) => {
        state.resource.data = file
        state.resource.error = null
      })
      .catch((error) => {
        state.resource.data = null
        state.resource.error = error
      });
    },
  }
} */